import request from '@/utils/request'

export function announcePeak() {
    return request({
        url: '/resource/v1/path/announce',
        method: 'get',
    })
}
